import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareProformaJiraFormBuilderRoute: InvariantJiraRoute = {
	name: 'project-settings-software-proforma-jira-form-builder',
	path: '/jira/software/projects/:projectKey/settings/forms/form/:templateFormId/edit',
	exact: true,
};
